CardView = require 'views/card/card-view'

module.exports = class CalendarCardView extends CardView
  onCalendar: true



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-card-view.coffee